import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import {AuthService} from './auth.service';
import {Router} from '@angular/router';
import {URL} from '../../global';
import {TranslateService} from '@ngx-translate/core';
import {NotificationService} from './notification.service';
import {GlobalErrorService} from './global-error.service';
import {SessionStorageService} from './session-storage.service';
import {UserService} from './members/user.service';

@Injectable({
    providedIn: 'root'
})

export class RequestService {

    constructor(public http: HttpClient,
                public auth: AuthService,
                private router: Router,
                public sessionStorageService: SessionStorageService,
                private userService: UserService,
                private translate: TranslateService,
                private errorLogService: GlobalErrorService,
                public notificationService: NotificationService) {
    }

    createAuthorizationHeader(login: boolean = false) {
        let accessToken: string;
        let header = new HttpHeaders();
        header = header.append('Content-Type', 'application/json');

        if (!login) {
            accessToken = this.sessionStorageService.getAccessTokenSession();
            header = header.append('X-Auth-Token', accessToken);
        }

        return header;
    }

    postData(func: string, data: any, type: string = 'put') {
        let header;
        if (func.indexOf('Auth/login') > -1) {
            header = this.createAuthorizationHeader(true);
        } else if (func.indexOf('activate') > -1) {
            header = this.createAuthorizationHeader(true);
        } else {
            header = this.createAuthorizationHeader();
        }
        let response: any;
        if (type == 'post') {
            response = this.http.post(URL() + func, data, {
                responseType: 'json',
                headers: header
            })
                .map((success: Object | any) => {
                    if (success['message'] == 'TOKEN-EXPIRED') {
                        this.userService.removeUser();
                        this.sessionStorageService.removeUserSession();
                        this.sessionStorageService.removeLanguageSession();
                        this.router.navigate(['/', 'sessions', 'signin']);
                    }
                    return success;
                })
                .catch((errors: HttpErrorResponse) => {
                    return this.handleError(errors);
                });
        } else {
            response = this.http.put(URL() + func, data, {
                responseType: 'json',
                headers: header
            })
                .map((success: Object) => {
                    if (success['message'] == 'TOKEN-EXPIRED') {
                        this.userService.removeUser();
                        this.sessionStorageService.removeUserSession();
                        this.sessionStorageService.removeLanguageSession();
                        this.router.navigate(['/', 'sessions', 'signin']);
                    }
                    return success;
                })
                .catch((errors: HttpErrorResponse) => {
                    return this.handleError(errors);
                });
        }
        return response;
    }

    private handleError(error: HttpErrorResponse | Response | any) {
        let errorToJson = {type: '', message: ''};
        error.error && typeof error.error == 'string' && error.status != 404 ? errorToJson = JSON.parse(error.error) : console.log('error', error);
        if (typeof errorToJson.message == 'string' && errorToJson.type != '') {
            if (errorToJson.message == 'TOKEN-EXPIRED') {
                this.userService.removeUser();
                this.sessionStorageService.removeUserSession();
                this.sessionStorageService.removeLanguageSession();
                this.router.navigate(['/', 'sessions', 'signin']);
            } else {
                this.translate.get([errorToJson.type, errorToJson.message]).subscribe((errorResponse: string) => {
                    this.notificationService.basicNoty(errorToJson.type, errorResponse[errorToJson.message], errorResponse[errorToJson.type]);
                });
            }
        } else {
            this.errorLogService.handleError(error);
        }
        return Observable.throw(error);
    }
}
